import React, { useState, memo } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './legal/PrivacyPolicy';
import { TermsConditions } from './legal/TermsConditions';
import { ContactInfo } from './legal/ContactInfo';
import { AffiliateDisclosure } from './legal/AffiliateDisclosure';
type ModalType = 'privacy' | 'terms' | 'contact' | 'affiliate' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const getModalContent = () => {
    switch (activeModal) {
      case 'privacy':
        return {
          title: 'Privacy Policy',
          content: <PrivacyPolicy data-id="element-39" />
        };
      case 'terms':
        return {
          title: 'Terms & Conditions',
          content: <TermsConditions data-id="element-40" />
        };
      case 'contact':
        return {
          title: 'Contact Us',
          content: <ContactInfo data-id="element-41" />
        };
      case 'affiliate':
        return {
          title: 'Affiliate Disclosure',
          content: <AffiliateDisclosure data-id="element-42" />
        };
      default:
        return {
          title: '',
          content: null
        };
    }
  };
  const {
    title,
    content
  } = getModalContent();
  return <>
      <footer className="relative z-10 bg-[#1e1235] text-slate-400 py-12 px-4 border-t border-white/5" data-id="element-43">
        <div className="max-w-5xl mx-auto" data-id="element-44">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-45">
            <div className="text-center md:text-left" data-id="element-46">
              <h3 className="text-white font-bold text-lg mb-4" data-id="element-47">
                Letters from Santa
              </h3>
              <p className="text-sm max-w-xs mx-auto md:mx-0" data-id="element-48">
                Creating magical Christmas memories for children around the
                world with personalized letters from the North Pole.
              </p>
            </div>

            <div className="flex flex-col items-center md:items-end gap-4" data-id="element-49">
              <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 text-sm" data-id="element-50">
                <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-51">
                  Privacy Policy
                </button>
                <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-52">
                  Terms & Conditions
                </button>
                <button onClick={() => setActiveModal('contact')} className="hover:text-white transition-colors" data-id="element-53">
                  Contact Us
                </button>
                <button onClick={() => setActiveModal('affiliate')} className="hover:text-white transition-colors" data-id="element-54">
                  Affiliate Disclosure
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 text-center text-xs" data-id="element-55">
            <p data-id="element-56">
              © {new Date().getFullYear()} Letters from Santa. All rights
              reserved.
            </p>
            <p className="mt-2 text-slate-500" data-id="element-57">
              This site is not affiliated with, endorsed by, or connected to
              Meta Platforms, Inc. in any way.
            </p>
          </div>
        </div>
      </footer>

      <Modal isOpen={!!activeModal} onClose={closeModal} title={title} data-id="element-58">
        {content}
      </Modal>
    </>;
}